import { Injectable } from '@angular/core';

import { DriverType } from '@shared/services/gql.service';
import { Option } from '@shared/types/components.type';

import { FullActivity, FullCategory } from '../../../state/category/category.query';

@Injectable({
  providedIn: 'root',
})
export class ForecastTableGridDriverService {
  DriverOptions: Option<DriverType>[] = [
    {
      label: 'Custom Curve',
      value: DriverType.DRIVER_CUSTOM,
    },
    {
      label: 'Patient',
      value: DriverType.DRIVER_PATIENT,
    },
    {
      label: 'Site',
      value: DriverType.DRIVER_SITE,
    },
    {
      label: 'Time',
      value: DriverType.DRIVER_TIME,
    },
  ];

  parseCategoryDriver(category: FullActivity | FullCategory): string {
    return category.primary_settings.driver || '';
  }

  parseCategoryDriverSettingId(category: FullActivity | FullCategory): string {
    return category.primary_settings.driver_setting_id || '';
  }
}
